import React from 'react';
import './Street.css';
import FMSimage from '../Assets/lights111.jpg'; // First image
import FMSimage2 from '../Assets/lights222.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/street3.png'; // Image for How it Works section
import FMSimage4 from '../Assets/street4.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/street5.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-card">
            <div className="FMS-container">
                {/* First Section: Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <h1 className="FMS-heading">STREET LIGHT CONTROL SYSTEM (CCMS)</h1>
                        <p className="FMS-description">
                            The state-of-the-art Centralized Web-Based Control and Monitoring System (CCMS) from Vajra IoT enables remote monitoring and control of street lights. It reduces energy theft and losses, identifies lighting failures promptly, and optimizes energy consumption, making it a vital solution for modern urban infrastructure.
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage} alt="Street Light Control System" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading Between Images */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
                </div>

                {/* Second Section: New Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Automatic Switching:</strong> Controls street light on/off based on programmed times to reduce power consumption.</li>
                                <li><strong>Traffic-Based Control:</strong> Alternates lights on/off based on nighttime traffic conditions for efficiency.</li>
                                <li><strong>GPS Real-Time Clock:</strong> Inbuilt GPS receiver ensures accurate time synchronization.</li>
                                <li><strong>Seasonal Adjustments:</strong> Automatically adapts timings to seasonal changes.</li>
                                <li><strong>Manual Switching:</strong> Offers manual control for flexibility.</li>
                                <li><strong>Retrofit Controller:</strong> Upgrades existing street lights into smarter systems.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: New Image for Key Features */}
                    <div className="FMS-image-container">
                        <img src={FMSimage2} alt="Key Features" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading for How it Works */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">How it Works</h2>
                </div>

                {/* Third Section: Layout for How it Works */}
                <div className="FMS-content-container">
                    {/* Left side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage3} alt="How It Works" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            The CCMS uses a web-based platform to monitor and control street lights across regions. It automatically switches lights on/off based on programmed schedules, adjusted by an inbuilt GPS receiver for accurate timing and seasonal changes. Traffic-based control optimizes lighting during low-traffic periods, while retrofit controllers and manual switching options enhance flexibility and efficiency.
                        </p>
                    </div>
                </div>

                {/* New Section: Why Choose Us */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Why Choose Our Street Light Control System</h2>
                </div>

                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Energy Efficiency:</strong> Reduces power consumption through automated and traffic-based controls.</li>
                                <li><strong>Theft Reduction:</strong> Real-time monitoring prevents energy theft and misuse.</li>
                                <li><strong>Reliability:</strong> Promptly identifies light failures for timely maintenance.</li>
                                <li><strong>Ease of Use:</strong> Centralized web-based system with manual and retrofit options simplifies management.</li>
                                <li><strong>Cost Savings:</strong> Minimizes energy losses and operational costs.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage4} alt="Why Choose CCMS" className="FMS-image" />
                    </div>
                </div>

                {/* New Section: Industries Using Our System */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Industries Using Our System</h2>
                </div>

                <div className="FMS-content-container reverse-order-last">
                    {/* Left side: Image for Industries */}
                    <div className="FMS-image-container">
                        <img src={FMSimage5} alt="Industries Using CCMS" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Our Street Light Control System is trusted by various sectors to optimize lighting management and enhance operational efficiency. These industries rely on our solution for its precision, reliability, and energy-saving benefits:
                            <ul>
                                <li>Urban Municipalities</li>
                                <li>Smart Cities</li>
                                <li>Highway Authorities</li>
                                <li>Industrial Complexes</li>
                                <li>Housing Societies & Gated Communities</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FMS;